module.exports = __webpack_public_path__ + "media/images/shared/downloads/apple-e2d575d5ace9ad33ae70a1913a99c59b.png";